import React from 'react';
import { PropTypes } from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Loader.css';
import cx from 'classnames';

function TextLoader({ loadingText }) {
    return (
        <div className={s.textCenter}>
            <p className={cx(s.saving, 'savaLoader')}>
                <span>{loadingText}</span>
                <span className={cx(s.savingDots, 'savingDotsLoader')}>
                    <span>.</span>
                    <span>.</span>
                    <span>.</span>
                </span>
            </p>
        </div>
    );
}

TextLoader.propTypes = {
    loadingText: PropTypes.string,
};

export default withStyles(s)(TextLoader);
